import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './assets/css/styles.css'; // Assuming you will have a CSS file for styles
import 'bootstrap/dist/css/bootstrap.min.css';

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);